/**
 * Test IDs for QA automation.
 */
export const testIds = {
  driverFormFirstName: "driver-form-first-name",
  driverFormMiddleName: "driver-form-middle-name",
  driverFormLastName: "driver-form-last-name",
  driverFormEldId: "driver-form-eld-id",
  driverFormExternalId: "driver-form-external-id",
  driverFormIsOwnerOperator: "driver-form-is-owner-operator",
  driverFormLicenseNumber: "driver-form-license-number",
  driverFormMedicalNumber: "driver-form-medical-number",
  driverFormRestriction: "driver-form-restriction",
  driverFormEmail: "driver-form-email",
  driverFormPassword: "driver-form-password",
  driverFormUploadDocument: "driver-form-upload-document",
  driverFormSave: "driver-form-save",
} as const;
